"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CradleLoader = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var CradleLoader = function CradleLoader(props) {
  return (
    /*#__PURE__*/
    _react["default"].createElement("div", {
      "aria-label": props.label,
      role: "presentation",
      className: "container"
    },
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "react-spinner-loader-swing"
    },
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "react-spinner-loader-swing-l"
    }),
    /*#__PURE__*/
    _react["default"].createElement("div", null),
    /*#__PURE__*/
    _react["default"].createElement("div", null),
    /*#__PURE__*/
    _react["default"].createElement("div", null),
    /*#__PURE__*/
    _react["default"].createElement("div", null),
    /*#__PURE__*/
    _react["default"].createElement("div", null),
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "react-spinner-loader-swing-r"
    })),
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "react-spinner-loader-shadow"
    },
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "react-spinner-loader-shadow-l"
    }),
    /*#__PURE__*/
    _react["default"].createElement("div", null),
    /*#__PURE__*/
    _react["default"].createElement("div", null),
    /*#__PURE__*/
    _react["default"].createElement("div", null),
    /*#__PURE__*/
    _react["default"].createElement("div", null),
    /*#__PURE__*/
    _react["default"].createElement("div", null),
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "react-spinner-loader-shadow-r"
    })))
  );
};

exports.CradleLoader = CradleLoader;
CradleLoader.propTypes = {
  label: _propTypes["default"].string
};
CradleLoader.defaultProps = {
  label: "audio-loading"
};